import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (param) {
  const { data, exec } = useRequest({
    url: '',
    name: 'GET_WORK_ORDER_DISPATCH_DELETE',
    method: 'DELETE',
  });

  useEffect(() => {
    if (param && JSON.stringify(param) !== '{}') {
      let url = `/api/devices/${param.device_id}/workorders/${param.id}/dispatch`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return data;
});
